/** biome-ignore-all lint/style/useNamingConvention: <naming comes from the env> */
import { z } from 'zod';

export const pianoEnvSchema = z.object({
  ONE_TRUST_DOMAIN_ID: z.string(),
});

export const { ONE_TRUST_DOMAIN_ID } = pianoEnvSchema.parse({
  ONE_TRUST_DOMAIN_ID: process.env.ONE_TRUST_DOMAIN_ID,
});

export interface OneTrustUser {
  dataSubjectParams: {
    isAnonymous: boolean;
    id?: string;
    token?: string;
  };
  geolocationResponse?: {
    stateCode: string;
    countryCode: string;
    regionCode?: string;
  };
}
